import React from "react";
import auth from "../../Auth";
import { download_excel, dataset_list } from "../../apis";

import Popup from "reactjs-popup";

// IMPORT MATERIAL-UI Components
import Typography from "@material-ui/core/Typography";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";

import { TableSubmit } from "./submit-datasets/TableSubmit";
import { ActionTableSubmit } from "./submit-datasets/ActionTableSubmit";
import SubmissionDialog from "./submit-datasets/SubmissionDialog";
import ErrorDialog from "./components/ErrorDialog";
import findErrors from "./components/helper";

const { config } = window;

export class Submission extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  initComponent = async () => {
    // add 9 rows
    this.pushRows(9);

    if (auth.tokenExpired()) {
      this.setState({
        popupErrors: "Session expired. Please login again",
      });
    }
  };

  initComponentNew = async () => {
    // add 9 rows
    this.pushRows(1);

    if (auth.tokenExpired()) {
      this.setState({
        popupErrors: "Session expired. Please login again",
      });
    }
  };

  addRows = (nRows, formControls) => {
    //formControls is and array of object then is passed by reference
    const currentIndex = formControls.slice(-1)[0][0].index;
    let row;
    let newIndex = currentIndex + 1;
    for (row = 0; row < nRows; row++) {
      let i;
      const newRow = [];
      for (i = 0; i < this.state.headers.length; i++) {
        const header = this.state.headers[i];
        const newItem = { id: header.id, index: newIndex, error: "" };

        // make sure that the default setting for visibility is set to private

        // TODO
        // get the default visibility from the backend

        // if (header.inputType === "select" && header.id === "visibility") {
        //   newItem.value = "private";
        // } else {
        //   newItem.value = "";
        // }  

        // initialize the rows with the expected default values
        if (header.id === "id") {
          newItem.value = "";
        }

        if (header.id === "file") {
          newItem.value = [];
        }

        if (header.id === "file2") {
          newItem.value = [];
        }

        if (header.id === "Comment") {
          newItem.value = "";
        }

        newRow.push(newItem);
      }
      //Push new row to formControls
      formControls.push(newRow);
      newIndex += 1;
    }
  };

  pushRows = (nRows) => {
    //Get current form control to later modify it
    const formControls = [...this.state.formControls];
    //Add Rows
    this.addRows(nRows, formControls);
    //Update Form Control State
    this.setState({
      formControls,
      numberRows: formControls.length,
    });
  };

  hasErrors = (formControls) => {
    if (formControls === null) {
      return true;
    }

    /*Checks if formControls has some type of Error*/
    for (let row of formControls) {
      for (let col of row) {
        if (col.error !== "") {
          return true;
        }
      }
    }
    return false;
  };

  checkRowFilled = (row) => {
    //Check if row is filled
    let nColumn = 0;
    for (let column of row) {
      const type = this.state.headers[nColumn].inputType;
      const { value } = column;

      switch (type) {
        case "text":
        case "textReadOnly":
        case "number":
          if (value !== "") return true;
          break;
        // case "select":
        case "select-experiment":
        case "select-participant":
          if (value !== "----" && value !== "") return true;
          break;
        case "selectMultiple":
          if (value.length === 1) {
            if (value[0] !== "----") return true;
          } else if (value.length > 1) {
            return true;
          }
          break;
      }
      nColumn += 1;
    }
    return false;
  };

  getFilledRows = (formControls) => {
    //Extract the rows that are filled from the form
    //returns nested list:
    //Array [ (5) […], (5) […] ]
    //0: Array(5) [ {…}, {…}, {…}, … ]
    //1: Array(5) [ {…}, {…}, {…}, … ]
    return formControls.filter(this.checkRowFilled);
  };

  // getNonEmptyRowIds = (formControls) => {
  //   const nonEmptyRows = [];

  //   for (const [i, row] of formControls.entries()) {
  //     let nonEmptyColsBool = false;
  //     for (const col of row) {
  //       if (!col.hasOwnProperty("value")) {
  //         continue;
  //       }

  //       if (Array.isArray) {
  //         if (col.value.length > 0) {
  //           nonEmptyColsBool = true;
  //         }
  //         continue;
  //       }

  //       if (col.value !== "") {
  //         nonEmptyColsBool = true;
  //         break;
  //       }
  //     }
  //     if (nonEmptyColsBool) {
  //       nonEmptyRows.push(i);
  //     }
  //   }

  //   return nonEmptyRows;
  // };
  
  getNonEmptyRowIds = (formControls, headers) => {
    const dropdownCols = headers
      .filter((header) => header.inputType === "select")
      .map((col) => col.id);

    

    const nonEmptyRows = [];
    for (const [i, row] of formControls.entries()) {
      let nonEmptyColsBool = false;
      for (const col of row) {
        if (!col.hasOwnProperty("value")) {
          continue;
        }
        if (Array.isArray(col.value) && col.value.length > 0) {
          nonEmptyColsBool = true;
          break;
        }
        if (
          !dropdownCols.includes(col.id) &&
          col.id != "file" &&
          col.value !== ""
        ) {
          nonEmptyColsBool = true;
          break;
        }
      }
      if (nonEmptyColsBool) {
        nonEmptyRows.push(i);
      }
    }
    return nonEmptyRows;
  };


  // FIXME
  // The button only works if you click on the top left corner of it
  // otherwise it doesn't work

  addRow = (event) => {
    const { id } = event.currentTarget;
    const nRows = parseInt(id.split("-")[1]);

    this.pushRows(nRows);
  };

  // todo
  // modify config js to type check values
  // specific columns should e.g. only allow numbers
  valueIsAllowed = (input, columnHeader) => {
    let allowedValues = columnHeader.selection;

    // value is allowed should work for other columns (=visibility as well)

    if (columnHeader.hasOwnProperty("allowedValues")) {
      allowedValues = columnHeader.allowedValues;
    }
    return allowedValues.includes(input)
      ? ""
      : `${input} is not a valid option!`;
  };

  validateForm = (formControls) => {
    // validateForm = async (formControls) => {
    // TODO
    // validate form should fail if form is empty
    // => show error message

    // TODO
    // make sure that the validate also works with bool values

    //Loop Form Controls
    for (let row of formControls) {
      // let checkRow = this.checkRowFilled(row);
      for (let column of row) {
        // if (checkRow) {
        const { value } = column;

        //1. Check if the field is mandatory
        const columnHeader = this.state.headers.find(
          (item) => item.id === column.id
        );
        if (columnHeader.mandatory) {
          if (value === "" || value === "select") {
            column.error = "This field is required.";
          } else {
            column.error =
              columnHeader.selection.length > 0
                ? this.valueIsAllowed(value, columnHeader)
                : "";
          }
        }
        // TODO
        // set the columns which were invalid to the default value
        if (column.error) {
          // TODO change state to validated false
        }
      }
    }
  };

  validateProjectSubmissionForm = (formRows) => {    //   // let checkRow = this.checkRowFilled(row);
    formRows.forEach((row) => {
      for (const column of row) {
        const { value } = column;

        //1. Check if the field is mandatory
        const columnHeader = this.state.headers.find(
          (item) => item.id === column.id
        );
        if (columnHeader.mandatory) {
          if (value === "" || value === "select") {
            column.error = "This field is required.";
          } else {
            column.error =
              columnHeader.selection.length > 0
                ? this.valueIsAllowed(value, columnHeader)
                : "";
          }
        }
        // TODO
        // set the columns which were invalid to the default value
        if (column.error) {
          // TODO change state to validated false
        }
      }
    });

    //get all individual dataset ids
    const projects = new Set();
    formRows.forEach((column) => {
      projects.add(column.filter((col) => col.id === "id")[0].value);
    });

    if (projects.length !== formRows.length) {
      let error_msg = "";
      projects.forEach((ds_id) => {
        const ids = [];

        for (const row of formRows) {
          // for (const rowId of nonEmptyRowIds) {
          //   const row = formRows[rowId];

          if (row.filter((col) => col.id === "id")[0].value === ds_id) {
            //check for duplicated dataset ids
            if (ids.includes(ds_id)) {
              error_msg = "project id already assigned";
            } else {
              ids.push(ds_id);
            }
            row.find((col) => col.id === "id").error = error_msg;
          }
        }
      });
    }
  };

  validateDataSubmissionForm = (formRows, nonEmptyRowIds) => {
    // FIXME
    // when selecting e.g. only healthy control in the first row
    // pressing validate will show an error message
    // with showing that in the row below
    // "undefined is not a valid option!" for the column Disease and the Column Healthy Control

    // validateForm = async (formControls) => {
    // TODO
    // validate form should fail if form is empty
    // => show error message

    // TODO
    // make sure that the validate also works with bool values

    //Loop Form Controls

    for (const rowId of nonEmptyRowIds) {
      const row = formRows[rowId];
      // let checkRow = this.checkRowFilled(row);
      for (let column of row) {
        // if (checkRow) {
        const { value } = column;

        //1. Check if the field is mandatory
        const columnHeader = this.state.headers.find(
          (item) => item.id === column.id
        );
        if (columnHeader.mandatory) {
          if (value === "" || value === "select") {
            column.error = "This field is required.";
          } else {
            column.error =
              columnHeader.selection.length > 0
                ? this.valueIsAllowed(value, columnHeader)
                : "";
          }
        }
        // TODO
        // set the columns which were invalid to the default value
        if (column.error) {
          // TODO change state to validated false
        }
      }
    }

    //get all individual dataset ids
    const datasets = new Set();
    formRows.forEach((column) => {
      datasets.add(column.filter((col) => col.id === "id")[0].value);
    });

    if (datasets.length !== formRows.length) {
      let error_msg = "";
      datasets.forEach((ds_id) => {
        const ids = [];

        for (const rowId of nonEmptyRowIds) {
          const row = formRows[rowId];

          if (row.filter((col) => col.id === "id")[0].value === ds_id) {
            //check for duplicated dataset ids
            if (ids.includes(ds_id)) {
              error_msg = "dataset id already assigned";
            } else {
              ids.push(ds_id);
            }
            row.find((col) => col.id === "id").error = error_msg;
          }
        }
      });
    }
  };

  resetStateForms = () => {
    //Reset all values
    const formControls = [...this.state.formControls];
    //Loop Form Controls to clean all values
    for (let row of formControls) {
      for (let column of this.state.headers) {
        const field = row.find((item) => item.id === column.id);
        field.value = Array.isArray(field.value) ? [] : "";
        field.error = "";
        /*Special case ValueIndex in ReactSelected*/
        if ("valueIndex" in field) {
          field.valueIndex = null;
        }
      }
    }
    //Update State
    this.setState({ formControls: formControls });
  };

  reload = (event) => {
    this.resetStateForms();
  };

  changeHandler = (event) => {
    const { name, value } = event.target;
    const id = name.split("-")[0];
    const index = name.split("-")[1];

    const currentFormControls = [...this.state.formControls];
    const rowControls = [...currentFormControls[index]];
    const fieldControl = rowControls.find((item) => {
      return item.id === id;
    });

    if (Array.isArray(fieldControl.value)) {
      const indexField = fieldControl.value.indexOf(value);
      if (indexField === -1) {
        fieldControl.value.push(value);
      } else {
        fieldControl.value.splice(indexField, 1);
      }
    } else {
      fieldControl.value = value;
    }

    // TODO
    // add this handler to the other change handlers as well

    //returns boolean if possible
    if (fieldControl.value === "true" || fieldControl.value == "false") {
      fieldControl.value = JSON.parse(fieldControl.value);
    }

    // FIXME
    // setting the field control value
    // if (id === "datasetVisibilityDefaultIsPrivate") {
    //   if (fieldControl.value === "visible to all") {
    //     fieldControl.value = false; //3tr default is public
    //
    //   } else {
    //     fieldControl.value = true;
    //   }
    // }

    this.setState((state) => {
      const formControls = state.formControls.map((item, j) => {
        return j === index ? rowControls : item;
      });
      return {
        formControls,
      };
    });

    // why do we need to do this?
    //Update Headers
    // this.setState({ headers: headers });
  };

  // is below needed?
  changeSelectAutocomplete = (newValue, actionMeta) => {
    /*on Change Hanler for AsyncPaginate react Select Component used for Experiment Selection*/
    const id = actionMeta.name.split("-")[0];
    const index = actionMeta.name.split("-")[1];
    /*Update State With Selected Value*/
    const rowControls = [...this.state.formControls[index]];
    const fieldControl = rowControls.find((item) => {
      return item.id === id;
    });
    /*Update Value*/
    fieldControl.valueIndex = newValue;
    fieldControl.value = newValue.label;
    this.setState((state) => {
      const formControls = state.formControls.map((item, j) => {
        return j === index ? rowControls : item;
      });
      return {
        formControls,
      };
    });
  };

  verifyDatasetId = async (value) => {
    // needed for filling the file upload table
    // using file_template.tsv

    if (value !== "") {
      const response = await dataset_list(
        auth.getToken(),
        config.api_endpoint,
        JSON.stringify({ dataset_id: "", project_id: "test" })
      );
      const data = await response.json();

      if (data.includes(value)) {
        return true;
      }
    }
  };

  loadFile = async (data) => {
    //* only accepts TSV files

    // This needs a test

    //TODO
    //check if file is TSV
    //if not TSV return error

    //Reset Forms
    this.resetStateForms();
    //Update Load Data to True
    this.setState({ loadData: true });
    //Get current form control to later modify it
    const formControls = [...this.state.formControls];
    //Loop Over all Data
    let isFirst = true;
    let rowNumber = 0;
    let headerTitles = [];

    for (const row of data) {
      //1. Avoid LogoutButton
      if (isFirst) {
        isFirst = false;
        headerTitles = row;
      } else {
        //Check if Form Controls has an array to fulfill it or not
        if (rowNumber >= formControls.length) {
          //Generate new item
          this.addRows(1, formControls);
        }
        let colNumber = 0;
        for (const column of row) {
          // TODO
          // better rename the variable column to value

          // TODO
          // update the selection columns based on the values in the template

          //Update value
          try {
            const { inputType, selection } = this.state.headers.filter(
              (item) => item.title === headerTitles[colNumber]
            )[0];

            const correctedColNumber = this.state.headers.findIndex(
              (item) => item.title === headerTitles[colNumber]
            );

            // const { inputType } = this.state.headers.filter(
            //   (item) => item.title === headerTitles[colNumber]
            // )[0];

            if (
              Array.isArray(formControls[rowNumber][correctedColNumber].value)
            ) {
              formControls[rowNumber][correctedColNumber].value.push(column);
            } else if (
              // only trigger if dataset id (used for file upload)
              formControls[rowNumber][correctedColNumber].id === "DatasetID"
            ) {
              /*Call API Endpoint*/
              const datasetIdIsValid = await this.verifyDatasetId(column);
              if (datasetIdIsValid) {
                formControls[rowNumber][colNumber].value = column;
                formControls[rowNumber][colNumber].valueIndex = {
                  value: 0,
                  label: column,
                };
                formControls[rowNumber][colNumber].error = "";
              }
            } else if (inputType === "select") {
              let input = column;
              if (column === "true") {
                input = true;
              } else if (column === "false") {
                input = false;
              }

              // if (formControls[rowNumber][correctedColNumber].id === "disease") {
              //   // check this.state.headers for the disease column
              //
              // }

              // FIXME
              // loadFile overwrites the restrictions of the project
              // e.g. if in the project a certain set of diseases is defined
              // and the user tries to load a template with a different set of diseases the template will be loaded

              // it fails for diseases but not for the visibility columns

              // however it should fail
              // same for the dataset visibility

              formControls[rowNumber][colNumber].value = input;
              formControls[rowNumber][colNumber].valueIndex = {
                value: 0,
                label: input,
              };
              formControls[rowNumber][colNumber].error = "";
            } else {
              formControls[rowNumber][correctedColNumber].value = column;
            }
            colNumber++;
          } catch (error) {
            // TODO
            // show error message
            // => "not all columns were filled please review the template"
            //    "or fill the missing columns manually"
          }
        }
        rowNumber++;
      }
    }
    this.validateForm(this.getFilledRows(formControls));

    //Update Form Control State
    this.setState({
      formControls,
      numberRows: formControls.length,
      loadData: false,
    });
  };

  getExcel = async (excelTemplate) => {
    let fn = "step0-project.xlsx";

    if (excelTemplate === "dataset") {
      fn = "step1-dataset.xlsx";
    } else if (excelTemplate === "file") {
      fn = "step2-file.xlsx";
    }

    await download_excel(
      auth.getToken(),
      config.api_endpoint,
      excelTemplate,
      fn
    );
  };

  // No longer needed?
  // closeModal = () => {
  //   this.setState({ popupErrors: "", uploading: false });
  // };
  closeModal = () => {
    if (this.state.popupErrors === "Session expired. Please login again") {
      auth.user.keycloak.logout();
    }
    this.setState({ popupErrors: "" });
  };

  render() {
    const excelTemplate = "dataset";
    const ERRORS = findErrors(this.state.formControls);

    /*Show popup in case an error with the loggin occurs*/

    // TODO
    // check if this is still needed?
    if (this.state.popupErrors) {
      return (
        <Popup open={true} closeOnDocumentClick onClose={this.closeModal}>
          <div>
            <button className="close" onClick={this.closeModal}>
              {" "}
              &times;{" "}
            </button>
            <div className="page-header">
              {" "}
              <h1> Logging error. </h1>{" "}
            </div>
            <div className="alert alert-warning">{this.state.popupErrors} </div>
          </div>
        </Popup>
      );
    }

    return (
      <div className={"mainContent"}>
        {this.state.redirect && ERRORS === 0 ? (
          <SubmissionDialog
            type={"Experiments"}
            onClose={() => this.setState({ redirect: false })}
            tableContents={this.state.redirectContents}
            filename={this.state.csvFileName}
            open={this.state.redirect}
          />
        ) : null}
        <Typography variant={"h5"} align={"center"}>
          {" "}
          Create Dataset/s{" "}
        </Typography>
        <ActionTableSubmit
          addRow={this.addRow}
          validate={this.validate}
          submit={this.submit}
          reload={this.reload}
          loadFile={this.loadFile}
          getExcel={() => this.getExcel(excelTemplate)}
          groups={this.state.groups}
          ownerHandler={this.ownerHandler}
        />
        {this.state.validated ? (
          <ErrorDialog
            onClose={() => this.setState({ validated: false })}
            errors={ERRORS}
            errorGroups={this.state.groups.error}
          />
        ) : null}
        <TableSubmit
          headers={this.state.headers}
          contents={this.state.formControls}
          changeHandler={this.changeHandler}
          // is this needed?
          copyReason={this.state.copyReason}
          // is this needed?
          changeSelectAutocomplete={this.changeSelectAutocomplete}
        />
        <Backdrop
          style={{ color: "white", zIndex: "100" }}
          open={this.state.uploading}
        >
          <CircularProgress color="inherit" />
          <Box>
            Rows submitted:{this.state.rowsSubmitted}/{this.state.filledRows}
          </Box>
        </Backdrop>
      </div>
    );
  }
}
